module.exports = __webpack_public_path__ + "static/media/about-sumy-1.eeba9a38.mp4";